import { Component, OnInit } from '@angular/core';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../_services/auth.service';
import { ValidationErrorMessageEnum } from '../constants/ValidationErrorMessageEnum';
// import * as moment from 'moment';
import { SpinnerService } from '../_core/spinner/spinner.service';
import { SnotifyService } from 'ng-snotify';
import { ServerInfoDataForm } from '../_models/ServerInfoDataForm';
import { MyErrorStateMatcher } from '../register/register.component';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  title = 'View User';
  

  userDataSession;
  userRoleId = 0;
  id: number;
  // User Specific ID's
  changePasswordForm: FormGroup;
  
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
  oldPasswordType: boolean = true;
  newPasswordType: boolean = true;
  confirmPasswordType: boolean = true;

  serverInfoDataForm:ServerInfoDataForm = new ServerInfoDataForm;

  globalUserDetailsId: number;

  constructor(private activatedRoute: ActivatedRoute,
                public spinnerService: SpinnerService,
                private router: Router,
                private authService: AuthService,
                private snotifyService: SnotifyService,
                private formbuilder: FormBuilder,) 
                {
    }

    ngAfterViewInit(): void {
    }

  ngOnInit() {
    this.globalUserDetailsId=0;
    this.userDataSession = this.authService.getUserData();
    this.userRoleId = this.userDataSession.userRoleId;
    this.globalUserDetailsId = this.userDataSession.userRoleId;

    this.createCPForm();
  }

  public cancelChangePassword(changePasswordForm: FormGroup){
    // redirect to dashboard
    this.changePasswordForm.reset();
    this.router.navigate(['/dashboard']);
  }

  createCPForm() {
    this.changePasswordForm = this.formbuilder.group({
        oldPassword: ['', [Validators.required, Validators.minLength(5)]],
        newPassword: ['', [Validators.required, Validators.minLength(5)]],
        confirmPassword: ['', [Validators.required, Validators.minLength(5)]],
       },
       { validator: this.checkIfMatchingPasswords('newPassword', 'confirmPassword') }
    );

    this.changePasswordForm.valueChanges
    .subscribe(data => this.onCPValueChanged(data));
  this.onCPValueChanged(); // (re)set validation messages now
}

public checkIfMatchingPasswords(passwordKey: string, passwordConfirmationKey: string) {
  return (group: FormGroup) => {
      let passwordInput = group.controls[passwordKey],
          passwordConfirmationInput = group.controls[passwordConfirmationKey];
      if (passwordInput.value !== passwordConfirmationInput.value) {
          return passwordConfirmationInput.setErrors({ notEquivalent: true })
      }
      else {
          return passwordConfirmationInput.setErrors(null);
      }
  }
}
public passwordMatchValidator(g: FormGroup) {
  return g.get('newPassword').value === g.get('confirmPassword').value
     ? null : {'mismatch': true};
}

onCPValueChanged(data?: any) {
  if (!this.changePasswordForm) {
    return;
  }
  const form = this.changePasswordForm;

  for (const field in this.changePasswordErrors) {
    // clear previous error message (if any)
    this.changePasswordErrors[field] = '';
    const control = form.get(field);

    if (control && control.dirty && !control.valid) {
      const messages = this.validationMessages[field];
      for (const key in control.errors) {
        this.changePasswordErrors[field] = messages[key] + ' ';
      }
    }
  }
}


changePasswordErrors = {
  'oldPassword': '',
  'newPassword': '',
  'confirmPassword': '',
  'mismatch': '',
  
};

validationMessages = {
  'oldPassword': {
    'required': 'Required',
    'minlength': 'Field must contain at least 5 characters.',
    'maxlength': 'Field must not contain more than 45 characters.'
  },
  'newPassword': {
    'required': 'Required',
    'minlength': 'Field must contain at least 5 characters.' ,
    'maxlength': 'Field must not contain more than 45 characters. '
  
  },
  'confirmPassword': {
      'required': 'Required',
      'minlength': 'Field must contain at least 5 characters.' ,
      'maxlength': 'Field must not contain more than 45 characters.' ,
      'mismatch': 'newPassword & confirmPassword must be same.' ,
      'mismatchedPasswords': 'New Password & ConfirmPassword must be same.' ,
      'matchingPasswords': 'New Password & ConfirmPassword must be same.' ,
      'notEquivalent': 'New Password & ConfirmPassword must be same. ',
    },
};
public saveChnagePassword(changePasswordForm: FormGroup){
  this.changePasswordForm.controls['oldPassword'].markAsTouched();
  if(this.changePasswordForm.valid){
    this.spinnerService.show();
    this.authService.changePassword(this.oldPassword,this.confirmPassword)
      .subscribe(
      data => {
        let userData = data as ServerInfoDataForm;
          let msg = userData.message;
          if(userData.msgCode === 1){
            this.spinnerService.hide();
              this.snotifyService.success(msg,  {
                  timeout: 7000,
                  showProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true
              });
              this.authService.logout();
          }else if(userData.msgCode === 2){
            this.spinnerService.hide();
              this.snotifyService.error(msg,  {
                  timeout: 7000,
                  showProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true
              });
          }
      },
      error => {
        this.spinnerService.hide();
          this.showErrorMsgFn(error);
      });
  }else {
    this.changePasswordForm.markAsTouched();
    for (let inner in this.changePasswordForm.controls) {
      this.changePasswordForm.get(inner).markAsTouched();
      this.changePasswordForm.get(inner).updateValueAndValidity();
    }
  }
  
}

showErrorMsgFn(error) { 
  let cusErroJson = JSON.parse(error['_body']);
  let customizedErrorMsg = cusErroJson.message + ': ' + cusErroJson.error.message;
      
      
  if(error.status === 401) {
      this.authService.logout();
  }
}

matcher = new MyErrorStateMatcher();
}
